import React from 'react';
import { BoxSelection, TextButton } from 'wix-ui-tpa/cssVars';
import { classes, st } from './slots.st.css';
import { useConfig } from '../../../contexts/config-context';
export const TimeSlots = () => {
  const [selectedId, setSelectedId] = React.useState('0');
  const {
    isMobile
  } = useConfig();
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, {
      isMobile
    })
  }, /*#__PURE__*/React.createElement(BoxSelection, {
    className: "",
    name: "hour-selection",
    label: "Tuesday, Jan 9",
    onChange: _ref => {
      let {
        id
      } = _ref;
      return setSelectedId(id);
    }
  }, /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.boxSelectionOption,
    id: "0",
    checked: selectedId === '0'
  }, "10:00 AM - 10:30 AM"), /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.boxSelectionOption,
    id: "1",
    checked: selectedId === '1'
  }, "10:30 AM - 11:00 AM"), /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.boxSelectionOption,
    id: "2",
    checked: selectedId === '2'
  }, "11:00 AM - 11:30 AM"), /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.boxSelectionOption,
    id: "3",
    checked: selectedId === '3'
  }, "12:30 PM - 1:00 PM"), /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.boxSelectionOption,
    id: "4",
    checked: selectedId === '4'
  }, "1:00 PM - 1:30 PM"), /*#__PURE__*/React.createElement(BoxSelection.Option, {
    className: classes.boxSelectionOption,
    id: "5",
    checked: selectedId === '5'
  }, "1:30 PM - 2:00 PM")), /*#__PURE__*/React.createElement(TextButton, {
    className: classes.textButton
  }, "Show more slots"));
};
//# sourceMappingURL=index.js.map